import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iframe", "progress", "step"]
  static values = {
    timestamps: Array
  }

  connect() {
    // Set initial opacity for all steps
    this.stepTargets.forEach(step => {
      step.style.opacity = "0.5"
    })
    this.initializePlayer()
  }

  async initializePlayer() {
    // Wait for Stream API to be available
    while (typeof Stream === 'undefined') {
      await new Promise(resolve => setTimeout(resolve, 100))
    }

    // Initialize player
    this.player = Stream(this.iframeTarget)
    
    // Track progress
    this.player.addEventListener('timeupdate', () => {
      try {
        const currentTime = this.player.currentTime
        const duration = this.player.duration
        
        if (duration > 0) {
          const progress = (currentTime / duration) * 100
          this.progressTarget.style.width = `${progress}%`
          
          // Update steps opacity based on current time
          this.stepTargets.forEach((step) => {
            const timestamp = parseFloat(step.dataset.timestamp)
            if (currentTime >= timestamp) {
              step.style.opacity = "1"
            } else {
              step.style.opacity = "0.5"
            }
          })
        }
      } catch (error) {
        // Silent error handling
      }
    })
  }

  async seekTo(event) {
    const timestamp = parseFloat(event.currentTarget.dataset.timestamp)

    if (this.player && timestamp) {
      try {
        this.player.currentTime = timestamp
      } catch (error) {
        // Silent error handling
      }
    }
  }
} 